<template>
    <v-card color="blue-grey lighten-5"
            dark
            dense>
        <v-card-text class="pa-0">
            <v-row class="ma-0">
                <v-row class="ma-0">
                    <v-menu v-for="(itm, index) in tramites.estadoTramite"
                            :key="index"
                            offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-chip v-on="on"
                                    v-bind="attrs"
                                    @click.stop="newTramite(itm.tramiteId)"
                                    small
                                    class="ma-1"
                                    :color="itm.default ? 'success' : 'primary'">
                                {{ itm.tramite.nombre }}
                            </v-chip>
                        </template>

                        <!-- si no necesitás contenido de menú, podés incluso borrar <v-menu> entero y dejar solo el v-chip -->
                    </v-menu>
                </v-row>

            </v-row>
        </v-card-text>
        <template>
            <v-dialog v-model="dialog"
                      max-width="400">
                <v-card>
                    <v-card-title class="pa-0">
                        <v-toolbar flat dense color="yellow">
                            <v-btn icon @click="close">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <v-toolbar-title>
                                Alerta de llamado
                            </v-toolbar-title>
                        </v-toolbar>
                    </v-card-title>

                    <v-card-text>
                        <v-container grid-list-md>
                            <v-row>
                                <v-layout wrap>
                                    <v-flex xs12>
                                        <fecha v-model="alertaFechaIn"
                                               label="Fecha">
                                        </fecha>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field v-model="alertaDescripcion"
                                                      label="Descripción">
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-row>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="erase">Borra</v-btn>
                        <v-btn text @click="save">Confirma</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>
    </v-card>

</template>
<script>
    import { mapState, mapActions, mapGetters } from 'vuex';
    import fecha from '@/components/Tools/Fecha';

    export default {
        name: 'guardaEstado',
        props: ['estadoId', 'completado'],
        data() {
            return {
                dialog: false,
                alertaId: 0,
                alertaDescripcion: '',
                alertaFechaIn: null,
                alertaFechaOut: null,
            };
        },
        computed: {
            ...mapState('guarda', [
                'item',
                'defaultTramite',
                'tramite',
                'nuevoTramite',
                'todosTramitesCompletados'
            ]),

            ...mapState('estado', ['all']),

            ...mapGetters('guarda', ['getAlerta']),

            alrt1() {
                let alrt = this.item.guardaAlerta.find(x => x.alertaId == 1);
                if (alrt) {
                    return alrt.alertaId;
                }

                return 0;
            },
            alrt2() {
                let alrt = this.item.guardaAlerta.find(x => x.alertaId == 2);
                if (alrt) {
                    return alrt.alertaId;
                }

                return 0;
            },
            propDialog: {
                get() {
                    return this.dialogTramite;
                },
                set(value) {
                    this.setDialogTramite(value);
                }
            },
            tramites() {
                this.tramitesCompletados();
                if (this.all.items !== undefined) {
                    var itmid = this.estadoId;
                    var r = this.all.items.find(function (itm) {
                        if (itmid === itm.id) {
                            return itm;
                        }
                    });
                    r.estadoTramite = r.estadoTramite.filter(
                        x => (
                            this.todosTramitesCompletados ||
                            (!this.todosTramitesCompletados &&
                                x.tramiteId !=
                                this.$store._modules.root.state.TRAMITES
                                    .FINALIZADO)) &&
                            (x.tramite.modulo & 8) == 8
                    );
                    return r;
                }
                return {};
            },
        },
        mounted() {
            this.getAll();
        },
        methods: {
            ...mapActions('guarda', [
                'newTramite',
                'pushChild',
                'setDialogTramite',
                'setAlerta',
                'tramitesCompletados'
            ]),
            ...mapActions('tramite', ['getAll']),

            clkalerta1() {
                this.setAlerta({ alertaId: 1, value: !(this.alrt1 == 1) });

                if (this.alrt1 == 1)
                    this.setAlerta({ alertaId: 2, value: false });
            },

            clkalerta2() {
                this.dialog = true;
                let ret = this.getAlerta(2);
                this.alertaFechaIn = ret.fInicio;
                this.alertaFechaOut = ret.fCierre;
                this.alertaDescripcion = ret.descripcion;
                this.alertaId = ret.alertaId;
            },

            close() {
                this.dialog = false;
            },

            save() {
                this.setAlerta({
                    alertaId: 2,
                    value: true,
                    fechaIn: this.alertaFechaIn,
                    fechaOut: this.alertaFechaOut,
                    descripcion: this.alertaDescripcion
                });

                if (this.alrt1 == 1)
                    this.setAlerta({ alertaId: 1, value: false });
                this.close()
            },

            erase() {
                this.setAlerta({
                    alertaId: 2,
                    value: false
                });
                this.close()
            }

        },

        components: {
            fecha
        }
    };
</script>
